<p-progressBar mode="indeterminate" *ngIf="loading"></p-progressBar>
<app-warehousing-page-header activeSection="shipment-work"
  [title]="direction === 'INBOUND' ? 'Inbound Warehouse Work' : 'Outbound Warehouse Work'"
  [subtitle]="direction === 'INBOUND'
    ? 'Count and receive transfers and shipment returns at the selected warehouse.'
    : 'Prepare transfers and dispatches leaving the selected warehouse.'"></app-warehousing-page-header>
<nav class="direction-tabs" aria-label="Warehouse work direction">
  <a [routerLink]="queueLink('OUTBOUND')" [queryParams]="queueParams()"
    [class.active]="direction === 'OUTBOUND'" [attr.aria-current]="direction === 'OUTBOUND' ? 'page' : null">
    <i class="pi pi-sign-out"></i> Outbound work</a>
  @if (canViewInbound()) {
    <a [routerLink]="queueLink('INBOUND')" [queryParams]="queueParams()"
      [class.active]="direction === 'INBOUND'" [attr.aria-current]="direction === 'INBOUND' ? 'page' : null">
      <i class="pi pi-sign-in"></i> Inbound work</a>
  }
</nav>
<section class="warehousing-table-card directory-filters">
  <div class="filter-field">
    <label for="workWarehouse">Warehouse</label>
    <p-select inputId="workWarehouse" [options]="warehouses" optionLabel="name" optionValue="id"
      [(ngModel)]="warehouseId" placeholder="Select a warehouse" [filter]="true" filterBy="name,code"
      (onChange)="warehouseChanged()" appendTo="body" styleClass="w-full"></p-select>
  </div>
  <div class="filter-field">
    <label for="workSearch">Search reference</label>
    <input pInputText id="workSearch" [(ngModel)]="searchText" (keyup.enter)="refresh(true)"
      placeholder="Shipment or delivery number" />
  </div>
  <div class="filter-field">
    <label for="workState">Work state</label>
    <p-select inputId="workState" [options]="states" optionLabel="label" optionValue="value"
      [(ngModel)]="state" (onChange)="refresh(true)" appendTo="body" styleClass="w-full"></p-select>
  </div>
  <p-button label="Search" icon="pi pi-search" (click)="refresh(true)" [disabled]="!warehouseId"></p-button>
  <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true"
    (click)="refresh()" [disabled]="!warehouseId"></p-button>
</section>
<section class="warehousing-table-card">
  <div class="warehousing-table-header">
    <div>
      <h2>{{ type === 'SHIPMENT' ? 'Shipments' : 'Deliveries' }} with pending {{ direction.toLowerCase() }} work</h2>
      <p>{{ warehouseName || 'Select a warehouse to begin' }}</p>
    </div>
    <span class="warehousing-result-chip">{{ total }} records</span>
  </div>
  <div class="directory-tabs">
    <p-button label="Shipments" icon="pi pi-truck" [outlined]="type !== 'SHIPMENT'"
      (click)="setType('SHIPMENT')"></p-button>
    <p-button label="Deliveries" icon="pi pi-map-marker" [outlined]="type !== 'DELIVERY'"
      (click)="setType('DELIVERY')"></p-button>
  </div>
  @if (!warehouseId) {
    <div class="warehousing-empty-state"><i class="pi pi-building"></i><strong>Choose a warehouse</strong>
      <span>The queue shows open work assigned to that warehouse.</span></div>
  } @else if (queueError) {
    <div class="warehousing-empty-state" role="alert"><i class="pi pi-exclamation-triangle"></i>
      <strong>Queue unavailable</strong><span>{{ queueError }}</span>
      <p-button label="Retry" icon="pi pi-refresh" (click)="refresh()"></p-button>
    </div>
  } @else {
    <p-table [value]="rows" [lazy]="true" [paginator]="true" [rows]="size" [first]="page * size"
      [totalRecords]="total" [rowsPerPageOptions]="[25, 50, 100]" (onLazyLoad)="loadPage($event)"
      styleClass="p-datatable-sm warehousing-data-table" [tableStyle]="{ 'min-width': '72rem' }">
      <ng-template pTemplate="header"><tr><th>Reference</th><th>Schedule</th><th>Route</th>
        <th>Pending work</th>@if (direction === 'INBOUND') { <th>Received / expected</th><th>Exceptions</th> }
        <th>Next action</th><th></th></tr></ng-template>
      <ng-template pTemplate="body" let-row><tr>
        <td><a [routerLink]="detailLink(row)" [queryParams]="detailParams()" class="warehousing-code-pill">{{ row.reference }}</a>
          @if (type === 'DELIVERY') { <small class="cell-meta">{{ row.shipmentNumber }}</small> }</td>
        <td>{{ row.schedule ? (row.schedule | date:'mediumDate') : '—' }}</td>
        <td>{{ row.route || '—' }}</td>
        <td>{{ row.pendingTransfers }} transfers@if (direction === 'INBOUND') {
          · {{ row.pendingReturns }} returns · {{ row.pendingShipmentInbounds || 0 }} shipment inbound } @else { · {{ row.pendingDispatches }} dispatches }</td>
        @if (direction === 'INBOUND') {
          <td>{{ row.inboundReceived || 0 }} / {{ row.inboundExpected || 0 }}</td>
          <td><p-tag [value]="'' + (row.exceptionCount || 0)"
            [severity]="row.exceptionCount ? 'danger' : 'secondary'"></p-tag></td>
        }
        <td>{{ row.nextAction }}</td>
        <td><p-button label="Open" icon="pi pi-arrow-right" size="small" [outlined]="true"
          [routerLink]="detailLink(row)" [queryParams]="detailParams()"></p-button></td>
      </tr></ng-template>
      <ng-template pTemplate="emptymessage"><tr><td [attr.colspan]="direction === 'INBOUND' ? 8 : 6" class="text-center py-5">
        No unfinished {{ direction.toLowerCase() }} work for this warehouse and filter.</td></tr></ng-template>
    </p-table>
  }
</section>
